import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Reportes" },
  { label: "Seguimiento General", icon: "fas fa-table", color: "#6366f1", bg: "#eef2ff", href: "/SeguimientoGeneral", desc: "Compras, embarque y entrega por modelo", perm: "menu_reportes" },
  { label: "Reportes Ventas", icon: "fas fa-chart-line", color: "#10b981", bg: "#f0fdf4", href: "/MenuReportesVentas", desc: "Reportes del área de ventas", perm: "menu_reportes" },
  { label: "Reportes Admin", icon: "fas fa-dollar-sign", color: "#3b82f6", bg: "#eff6ff", href: "/MenuReportesAdmin", desc: "Reportes administrativos", perm: "menu_reportes" },
  { label: "Dashboards", icon: "fas fa-chart-bar", color: "#f59e0b", bg: "#fffbeb", href: "/Dashboards", desc: "Tableros gráficos", perm: "menu_reportes" },
];

function BotonesReportes() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-chart-bar" color="#0ea5e9" bg="#f0f9ff" title="Reportes" subtitle="Reportes y tableros del sistema" />
        <div className="row">
          {ITEMS.map((r, i) =>
            r.type === "section"
              ? <MenuSection key={i} title={r.label} />
              : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
          )}
        </div>
      </div>
    </>
  );
}

export default BotonesReportes;
